import { useQuery } from '@tanstack/react-query';
import { useInjection } from 'inversify-react';
import { ConsultantDeadlinesService } from '../../services/consultant/consultant-deadlines.service';
import type { IConsultantDeadlinesService } from '../../services/consultant/consultant-deadlines.service.interface';
import { useAuthUser } from '../use-auth-user';

const NO_CANDIDATES: never[] = [];

/** Prefisso comune alle altre chiavi dello scadenzario: l'invalidazione per consulente le copre tutte. */
export const consultantDeadlineAssigneesKey = (consultantUserId: string, tenantId: string) =>
  ['consultant-deadlines', consultantUserId, 'assignees', tenantId] as const;

/** Le persone si assegnano cliente per cliente: senza un `tenantId` la query non parte. */
export function useConsultantDeadlineAssignees(
  tenantId: string,
  options: { enabled?: boolean } = {},
) {
  const service = useInjection<IConsultantDeadlinesService>(ConsultantDeadlinesService);
  const consultantUserId = useAuthUser()?.sub ?? '';
  const isEnabled = tenantId !== '' && consultantUserId !== '' && (options.enabled ?? true);

  const { data, isLoading, isError } = useQuery({
    queryKey: consultantDeadlineAssigneesKey(consultantUserId, tenantId),
    queryFn: () => service.getAssigneeCandidates(tenantId),
    enabled: isEnabled,
    staleTime: 60_000,
  });

  return { assigneeCandidates: data ?? NO_CANDIDATES, isLoading: isEnabled && isLoading, isError };
}
